
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/antara/tutorials/overview-of-antara-modules-part-ii",
      function () {
        return require("private-next-pages/en/docs/antara/tutorials/overview-of-antara-modules-part-ii/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/antara/tutorials/overview-of-antara-modules-part-ii"])
      });
    }
  